/**
 * 根路径与无 locale 前缀访问的语言重定向（06 开发文档 LocaleRouter）。
 * 优先级：localStorage 语言偏好 → 默认语言（zh-CN）。
 */
import { Navigate } from 'react-router';
import { defaultLocale } from './locales';
import { readLocalePreference } from '@/lib/locale';

export function LanguageRedirect() {
  const preferred = readLocalePreference();
  return <Navigate to={`/${preferred ?? defaultLocale}`} replace />;
}
